import {useEffect} from 'react';

import {isDefined, setSelectedResectionPlanePair} from '@/library';
import {useGlobalState} from '@/state';
import {type VtkStateRef} from '@/types';

export default function useSetPair({vtkState}: {vtkState: VtkStateRef}) {
	const {
		customDefaults,
		resectionPlanes,
		user: {user},
	} = useGlobalState();
	useEffect(() => {
		async function apply() {
			if (
				customDefaults.resectionPlanes.pair.applied ||
				resectionPlanes.state !== 'ready' ||
				!isDefined(user)
			) {
				return;
			}

			const pair = user.customDefaults?.resectionPlanes?.pair;

			if (isDefined(pair) && pair !== resectionPlanes.selectedPairKey) {
				await setSelectedResectionPlanePair({pair, vtkState});
			}

			customDefaults.resectionPlanes.pair.setApplied(true);
		}

		apply().catch(console.error);
	}, [
		customDefaults.resectionPlanes.pair.applied,
		resectionPlanes.state,
		user,
	]);
}
